module.exports = __webpack_public_path__ + "static/media/boy_with_backpack.1cf682f1.webp";